import { ClaimBirthdayRewardDto, MessageResponseDto } from "@api/api";
import { getApiErrorMessage } from "@core/utility/get-error-message";
import { authHeaders } from "@factory/authentication/auth-header";
import { useSessionContext } from "@factory/authentication/session.context";
import { claimBirthdayRewardController, sendEmailController, SendEmailModel, uploadEmailImageController, UploadEmailImageModel } from "@factory/model/query-model-person";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";

export function useQySendEmail(
  onSuccess?:
    | ((data: MessageResponseDto) => void | Promise<unknown>)
    | undefined,
  onError?: ((error: unknown) => void | Promise<unknown>) | undefined
) {
  const { checkSession } = useSessionContext();
  const queryClient = useQueryClient();
  const { showProgress, hideProgress, showError } = useNotificationContext();

  const apiFn = async (payload: SendEmailModel) => {
    await checkSession();

    showProgress();
    const operation = await sendEmailController(
      payload,
      authHeaders()
    );
    const response = (await operation()).data;
    return response as any;
  };

  return useMutation({
    mutationFn: apiFn,
    onSuccess: (response) => {
      hideProgress();
      if (onSuccess) {
        onSuccess(response);
      }
    },
    onError: (err: AxiosError) => {
      hideProgress();
      const message = getApiErrorMessage(err);
      showError(message);

      if (onError) {
        onError(err);
      }
    },
    onSettled() {
      hideProgress();
    },
  });
}

export function useQyUploadEmailImage(
  onSuccess?:
    | ((data: MessageResponseDto) => void | Promise<unknown>)
    | undefined,
  onError?: ((error: unknown) => void | Promise<unknown>) | undefined
) {
  const { checkSession } = useSessionContext();
  const queryClient = useQueryClient();
  const { showProgress, hideProgress, showError } = useNotificationContext();

  const apiFn = async (payload: UploadEmailImageModel) => {
    await checkSession();

    showProgress();
    const operation = await uploadEmailImageController(
      payload.file,
      authHeaders()
    );
    const response = (await operation()).data;
    return response as any;
  };

  return useMutation({
    mutationFn: apiFn,
    onSuccess: (response) => {
      hideProgress();
      if (onSuccess) {
        onSuccess(response);
      }
    },
    onError: (err: AxiosError) => {
      hideProgress();
      const message = getApiErrorMessage(err);
      showError(message);

      if (onError) {
        onError(err);
      }
    },
    onSettled() {
      hideProgress();
    },
  });
}

export function useQyClaimBirthdayReward(
  onSuccess?:
    | ((data: MessageResponseDto) => void | Promise<unknown>)
    | undefined,
  onError?: ((error: unknown) => void | Promise<unknown>) | undefined
) {
  const queryClient = useQueryClient();
  const { showProgress, hideProgress, showError } = useNotificationContext();

  const apiFn = async (payload: ClaimBirthdayRewardDto) => {
    showProgress();
    const operation = await claimBirthdayRewardController(
      payload,
    );
    const response = (await operation()).data;
    return response as any;
  };

  return useMutation({
    mutationFn: apiFn,
    onSuccess: (response) => {
      hideProgress();
      if (onSuccess) {
        onSuccess(response);
      }
    },
    onError: (err: AxiosError) => {
      hideProgress();
      const message = getApiErrorMessage(err);
      showError(message);

      if (onError) {
        onError(err);
      }
    },
    onSettled() {
      hideProgress();
    },
  });
}